exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo[data-v-fbf4bfea]{background-repeat:no-repeat!important;background-size:cover!important}", ""]);

// exports
